import { FunctionComponent, useState } from "react";
import { Questionnaire } from "fhir/r5";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";
import JanusPage from "../../components/JanusPage/JanusPage";
import CodeEditor from "../../components/CodeEditor/CodeEditor";
import { ToastQueueProvider } from "../../components/ToastQueueProvider/ToastQueueProvider";
import ErrorManagementService from "../../services/ErrorManagementService";
import QuestionnaireService from "../../services/QuestionnaireService";
import styles from "./AddQuestionnaire.module.css";

const AddQuestionnaire: FunctionComponent = () => {
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [validationErrors, setValidationErrors] = useState<any[]>([]);
  const { createToast } = ToastQueueProvider.useToastQueue();
  const navigate = useNavigate();

  async function onCreate() {
    if (saving) return;
    if (validationErrors.length > 0) {
      ErrorManagementService.errorToast(new Error(validationErrors[0].message), createToast);
      return;
    }

    let questionnaire: Questionnaire;
    try {
      questionnaire = JSON.parse(content);
      if (!questionnaire || questionnaire.resourceType !== "Questionnaire") {
        throw new Error(i18n.t("text.questionnairejsonrequired"));
      }
    } catch (error) {
      ErrorManagementService.errorToast(
        error instanceof SyntaxError ? new Error(i18n.t("text.invalidjson")) : error,
        createToast
      );
      return;
    }

    setSaving(true);
    try {
      const created = await QuestionnaireService.createQuestionnaire(questionnaire);
      if (!created.id) throw new Error(i18n.t("text.questionnairemissingid"));
      navigate("/Questionnaire/" + created.id);
    } catch (error) {
      ErrorManagementService.errorToast(error, createToast);
    } finally {
      setSaving(false);
    }
  }

  return (
    <JanusPage titleKey="title.editquestionnaire" loading={false} fitFooter needsLogin>
      <>
        <div className={styles.codeEditorFrame}>
          <CodeEditor content={content} setContent={setContent} setErrors={setValidationErrors} height="55vh" />
        </div>
        <Button variant="primary" onClick={onCreate} disabled={saving}>
          {saving ? i18n.t("button.saving") : i18n.t("button.save")}
        </Button>
      </>
    </JanusPage>
  );
};

export default AddQuestionnaire;
